import Component from './DownloadClinicalDropdown';
import createRenderer from './DownloadClinicalDropdown.relay';
export default createRenderer(Component);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/DownloadClinicalDropdown/index.js